import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import EmdPaidTables from "./table/EmdPaidTables";
import { singleAuctionDetails } from "../../../../redux/action/singleAuction";
import { getSingleOfferForSeller } from "../../../../redux/action/singleBrand";
import AuctionSchedule from "../comman/AuctionSchedule";
import ServiceScrapDetail from "./components/ServiceScrapDetail";

function SingleServiceLotDetails() {
  const { id, offerId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { singleAuctionData, loading } = useSelector(
    (pre) => pre?.singleAuction
  );
  const { singleOfferData, loadings } = useSelector((pre) => pre?.singleBrand);

  useEffect(() => {
    dispatch(singleAuctionDetails(id));
    dispatch(getSingleOfferForSeller(offerId));
  }, [dispatch, offerId, id]);


  return (
    <div className="">
      <span className={`valign-wrapper `} style={{ gap: "25px" }}>
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate(-1)}
        >
          arrow_back
        </span>
        <h4>Lots Service Details</h4>
      </span>

      <AuctionSchedule
        singleAuctionData={singleAuctionData}
        loading={loading}
      />
      <div className="full-width mt-2">
        <ServiceScrapDetail loadings={loadings} singleOfferData={singleOfferData} />
        <h4 className="font-cercular-bold cercle-purple-text">
          EMD Paid Members
        </h4>
        <EmdPaidTables
          paidEmdDetails={singleOfferData?.depositedBy}
          loading={loadings}
        />
      </div>
    </div>
  );
}

export default SingleServiceLotDetails;
